/* Dawn BOGOS / Color Ring gift module
   Contract: Liquid owns slot visibility (data-dd-bogos-qualified, has-gift, hidden on [data-dd-bogos-slot]).
   This file hydrates BOGOS offer detail and the card markup; it does not override those flags from client cart math. */
(function () {
  'use strict';

  if (window.DDCartGift) return;

  var BOGOS_EVAL_TIMEOUT_MS = 600;
  var MAX_CLAIM_RETRIES = 4;
  function getColorRingThresholdCents() {
    var slot = getPrimarySlot();
    if (slot) {
      var fromDom = parseInt(slot.getAttribute('data-dd-color-ring-threshold-cents') || '', 10);
      if (!isNaN(fromDom) && fromDom > 0) return fromDom;
    }
    var w = typeof window !== 'undefined' ? window.DD_COLOR_RING_THRESHOLD_CENTS : null;
    if (typeof w === 'number' && w > 0) return w;
    return 0;
  }
  var _inited = false;
  var _evalTimer = null;
  var _evalToken = 0;
  var _claimRetryCount = 0;
  var _eventRefreshInFlight = null;
  var _lastSectionRefreshTs = 0;

  function debugGift(eventName, payload) {
    if (!window.__ddCartDebug) return;
    try {
      console.info('[dd-cart-gift-debug]', eventName, payload || {});
    } catch (_) {}
  }

  function getState() {
    return window.DDCartState ? window.DDCartState.get() : null;
  }

  function patchState(next) {
    if (!window.DDCartState) return null;
    return window.DDCartState.patch(next || {});
  }

  function getSlots() {
    return document.querySelectorAll('[data-dd-bogos-slot]');
  }

  function getPrimarySlot() {
    return (
      document.querySelector('[data-dd-bogos-slot="mini"]') ||
      document.querySelector('[data-dd-bogos-slot="cart"]') ||
      null
    );
  }

  function syncFromAttributes() {
    var slot = getPrimarySlot();
    if (!slot || !window.DDCartState) return;
    patchState({
      thresholdMet: slot.getAttribute('data-dd-bogos-threshold-met') === 'true',
      hasColorRingInCart: slot.getAttribute('data-dd-bogos-has-gift') === 'true'
    });
  }

  function getDomBogosFlags() {
    var slot = getPrimarySlot();
    if (!slot) return null;
    return {
      thresholdMet: slot.getAttribute('data-dd-bogos-threshold-met') === 'true',
      qualifies: slot.getAttribute('data-dd-bogos-qualified') === 'true',
      hasGift: slot.getAttribute('data-dd-bogos-has-gift') === 'true'
    };
  }

  function clearEvalTimer() {
    if (_evalTimer) {
      clearTimeout(_evalTimer);
      _evalTimer = null;
    }
  }

  function scheduleEvalFallback() {
    clearEvalTimer();
    _evalToken += 1;
    var token = _evalToken;
    patchState({ evaluated: false });
    _evalTimer = setTimeout(function () {
      var state = getState();
      _evalTimer = null;
      if (!state || token !== _evalToken) return;
      if (state.hasColorRingInCart || state.pendingClaim || state.busy) return;
      if (state.qualifies === true) {
        patchState({ evaluated: true });
        renderAll();
        return;
      }
      if (state.thresholdMet) {
        patchState({ evaluated: true });
        renderAll();
        return;
      }
      var domFlags = getDomBogosFlags();
      if (domFlags && (domFlags.hasGift || domFlags.qualifies)) {
        patchState({
          hasColorRingInCart: domFlags.hasGift,
          qualifies: true,
          evaluated: true
        });
        renderAll();
        return;
      }
      patchState({ qualifies: false, detail: null, evaluated: true });
      renderAll();
    }, BOGOS_EVAL_TIMEOUT_MS);
  }

  function resolveEval() {
    clearEvalTimer();
    _evalToken += 1;
    patchState({ evaluated: true });
  }

  function shouldSkipBogosSuppressTarget(el) {
    if (!el || typeof el.closest !== 'function') return true;
    if (el.closest('[data-dd-bogos-slot]')) return true;
    if (el.classList && el.classList.contains('dd-bogos-msg-capture')) return true;
    if (el.closest('.dd-bogos-msg-capture')) return true;
    return false;
  }

  function suppressBogosDuplicateNode(el) {
    if (!el || shouldSkipBogosSuppressTarget(el)) return;
    try {
      el.setAttribute('aria-hidden', 'true');
      el.style.setProperty('display', 'none', 'important');
      el.style.setProperty('visibility', 'hidden', 'important');
      el.style.setProperty('pointer-events', 'none', 'important');
    } catch (err) {}
  }

  function hideDefaultBogosUi() {
    var popup = document.getElementById('freegifts-main-popup-container');
    if (popup) popup.style.display = 'none';
    var page = document.getElementById('freegifts-main-page-container');
    if (page) page.style.display = 'none';

    var roots = [];
    var cd = document.getElementById('CartDrawer');
    var mi = document.getElementById('main-cart-items');
    var shell = document.querySelector('cart-drawer.dd-cart-parity');
    if (cd) roots.push(cd);
    if (mi) roots.push(mi);
    if (shell) roots.push(shell);

    var selectorHits = [
      '.sca-promotion-message',
      '#sca-promotion-message-layout',
      '[data-bogos-message]',
      '.bogos-promotion-widget',
      '[id^="bogos-cart-widget"]',
      '[class*="bogos-promotion"]',
      '[class*="bogos_cart_message"]',
      '.gift-container-bogos',
      '.bogos-io-cart-offer'
    ];

    for (var r = 0; r < roots.length; r++) {
      var root = roots[r];
      for (var s = 0; s < selectorHits.length; s++) {
        var found = root.querySelectorAll(selectorHits[s]);
        for (var i = 0; i < found.length; i++) {
          suppressBogosDuplicateNode(found[i]);
        }
      }
      var msgViews = root.querySelectorAll('.bogos-cart-message-view');
      for (var j = 0; j < msgViews.length; j++) {
        if (msgViews[j].classList && msgViews[j].classList.contains('dd-bogos-msg-capture')) continue;
        suppressBogosDuplicateNode(msgViews[j]);
      }
    }
  }

  var _bogosHideTimer = null;
  function scheduleBogosUiSuppress() {
    hideDefaultBogosUi();
    if (_bogosHideTimer) clearTimeout(_bogosHideTimer);
    _bogosHideTimer = setTimeout(function () {
      _bogosHideTimer = null;
      hideDefaultBogosUi();
    }, 220);
  }

  function esc(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function getGiftList(detail) {
    if (!detail || typeof detail !== 'object') return [];
    if (detail.giftsOffer && Array.isArray(detail.giftsOffer.arrGiftShow)) return detail.giftsOffer.arrGiftShow;
    if (Array.isArray(detail.gifts)) return detail.gifts;
    return [];
  }

  function hasGiftPayload(detail) {
    if (!detail || typeof detail !== 'object') return false;
    if (Object.prototype.hasOwnProperty.call(detail, 'gifts') && Array.isArray(detail.gifts)) return true;
    if (
      detail.giftsOffer &&
      typeof detail.giftsOffer === 'object' &&
      Object.prototype.hasOwnProperty.call(detail.giftsOffer, 'arrGiftShow')
    ) {
      return Array.isArray(detail.giftsOffer.arrGiftShow);
    }
    return false;
  }

  function getPrimaryVariant(gift) {
    if (!gift || !Array.isArray(gift.variants) || !gift.variants.length) return null;
    return gift.variants[0];
  }

  function normalizeGiftProductHandles(raw) {
    if (raw == null || typeof raw !== 'string') return [];
    return raw
      .split(',')
      .map(function (x) {
        return String(x || '')
          .trim()
          .toLowerCase();
      })
      .filter(Boolean);
  }

  /** Handles from BOGOS slot (preferred) or theme bootstrap — must match Liquid gift detection. */
  function getConfiguredGiftProductHandles() {
    var slot = getPrimarySlot();
    var fromSlot = slot && slot.getAttribute('data-dd-bogos-gift-handles');
    if (fromSlot != null && String(fromSlot).trim() !== '') {
      return normalizeGiftProductHandles(String(fromSlot));
    }
    var w = typeof window !== 'undefined' ? window.DD_COLOR_RING_GIFT_PRODUCT_HANDLES : '';
    if (typeof w === 'string' && w.trim() !== '') return normalizeGiftProductHandles(w);
    return [];
  }

  /**
   * Gift line only: BOGOS gift product handle(s) from theme settings, or 🎁 title, or $0 color-ring heuristic.
   * Sellable PDP color ring (separate product) must NOT match unless configured as a gift handle.
   */
  function isColorRingGiftItem(item) {
    if (!item || typeof item !== 'object') return false;
    var rawTitle = String(item.title || item.product_title || '');
    if (rawTitle.indexOf('🎁') !== -1) return true;
    var h = String(item.handle || item.product_handle || '').toLowerCase();
    var t = rawTitle.toLowerCase();
    var fp = typeof item.final_price === 'number' ? item.final_price : null;
    var configured = getConfiguredGiftProductHandles();
    for (var i = 0; i < configured.length; i++) {
      if (configured[i] && h === configured[i]) return true;
    }
    if (h.indexOf('color-ring') !== -1 && fp === 0) return true;
    if (t.indexOf('color ring') !== -1 && fp === 0) return true;
    return false;
  }

  function isProtectionLineItem(item) {
    if (!item || typeof item !== 'object') return false;
    if (Number(item.product_id || 0) === 10266015924541) return true;
    var props = item.properties && typeof item.properties === 'object' ? item.properties : null;
    if (props && (props._dd_shipping_protection || props.dd_shipping_protection)) return true;
    var h = String(item.handle || item.product_handle || '').toLowerCase();
    var v = String(item.vendor || '').toLowerCase();
    var t = String(item.title || item.product_title || '').toLowerCase();
    if (h === 'dd-shipping-protection') return true;
    if (v.indexOf('insureshield') !== -1 || v.indexOf('insure shield') !== -1) return true;
    if (t.indexOf('shipping protection') !== -1 || t.indexOf('shipping insurance') !== -1) return true;
    return false;
  }

  function lineHasAnyPriceField(item) {
    if (!item || typeof item !== 'object') return false;
    return (
      typeof item.final_line_price === 'number' ||
      typeof item.line_price === 'number' ||
      typeof item.final_price === 'number' ||
      typeof item.price === 'number'
    );
  }

  function lineCentsForCartLine(item) {
    if (!item || typeof item !== 'object') return 0;
    if (typeof item.final_line_price === 'number') return item.final_line_price;
    if (typeof item.line_price === 'number') return item.line_price;
    var q = typeof item.quantity === 'number' && item.quantity > 0 ? item.quantity : 1;
    if (typeof item.final_price === 'number') return item.final_price * q;
    if (typeof item.price === 'number') return item.price * q;
    return 0;
  }

  function cartSubtotalExcludingProtection(cartData) {
    if (!cartData || !Array.isArray(cartData.items)) return 0;
    var sum = 0;
    for (var i = 0; i < cartData.items.length; i++) {
      var line = cartData.items[i];
      if (isProtectionLineItem(line)) continue;
      sum += lineCentsForCartLine(line);
    }
    return sum;
  }

  /** Sum is 0 but at least one merchandise line has no numeric price fields — cannot trust the sum. */
  function cartLinePricesUnreliable(cartData, sum) {
    if (!cartData || !Array.isArray(cartData.items)) return false;
    if (sum !== 0) return false;
    for (var i = 0; i < cartData.items.length; i++) {
      var it = cartData.items[i];
      if (isProtectionLineItem(it)) continue;
      if (!lineHasAnyPriceField(it)) return true;
    }
    return false;
  }

  function resolveThresholdMet(cartData, prevThresholdMet) {
    var cents = getColorRingThresholdCents();
    if (!cents) return false;
    var sum = cartSubtotalExcludingProtection(cartData);
    if (cartLinePricesUnreliable(cartData, sum)) {
      var slot = getPrimarySlot();
      var domMet = slot && slot.getAttribute('data-dd-bogos-threshold-met') === 'true';
      return domMet || !!prevThresholdMet;
    }
    return sum >= cents;
  }

  /**
   * Liquid sets data-dd-bogos-threshold-met from the same cart as suppress_promo on the banner.
   * OR with cart JSON so a bad/stale client sum cannot hide the offer while the server says above.
   * If cart line prices are reliable and sum is below threshold, trust cart over a stale DOM true
   * (e.g. granular drawer patch skipped refreshing the slot).
   * Never write data-dd-bogos-threshold-met from JS — wrong sum poisons DOM fallbacks.
   */
  function mergeThresholdMet(cartData, prevThresholdMet) {
    var slot = getPrimarySlot();
    var domMet = !!(slot && slot.getAttribute('data-dd-bogos-threshold-met') === 'true');
    if (!cartData || !Array.isArray(cartData.items)) return domMet;

    var sum = cartSubtotalExcludingProtection(cartData);
    var unreliable = cartLinePricesUnreliable(cartData, sum);
    var cartMet = resolveThresholdMet(cartData, prevThresholdMet);

    /* When cart math is reliable and says "below", still honor Liquid's threshold flag.
       Liquid uses the same cart but can differ (protection detection, line fields, discounts). */
    if (!unreliable && !cartMet) {
      return domMet;
    }
    return domMet || cartMet;
  }

  /**
   * dd-cart-helpers sets _latestCartData and replaces section HTML before publishCartUpdate.
   * rehydrateBogosVisibility → renderAll runs in that gap with stale DDCartState.thresholdMet.
   * Always merge tier + gift line facts from the latest cart JSON (or fresh slot attrs) first.
   */
  function syncTierStateBeforeRender() {
    var state = getState();
    if (!state) return;

    var cart =
      window.ddCartHelpers && typeof window.ddCartHelpers.getLatestCart === 'function'
        ? window.ddCartHelpers.getLatestCart()
        : null;
    if (cart && Array.isArray(cart.items)) {
      var thresholdMet = mergeThresholdMet(cart, !!state.thresholdMet);
      var hasGiftNow = cart.items.some(function (item) {
        return isColorRingGiftItem(item);
      });
      if (!thresholdMet) {
        clearEvalTimer();
        patchState({
          hasColorRingInCart: hasGiftNow,
          thresholdMet: false,
          qualifies: false,
          detail: null,
          evaluated: true
        });
        return;
      }
      patchState({
        hasColorRingInCart: hasGiftNow,
        thresholdMet: true
      });
      if (hasGiftNow) {
        resolveEval();
        patchState({ qualifies: true });
      }
      return;
    }
    var slot = getPrimarySlot();
    if (slot && window.DDCartState) {
      patchState({
        thresholdMet: slot.getAttribute('data-dd-bogos-threshold-met') === 'true',
        hasColorRingInCart: slot.getAttribute('data-dd-bogos-has-gift') === 'true'
      });
    }
  }

  function scrollVariantIntoView(variantId) {
    if (!variantId) return false;
    var id = String(variantId);
    var selectors = [
      '#CartDrawer [data-dd-cart-item][data-variant-id="' + id + '"]',
      'cart-drawer [data-dd-cart-item][data-variant-id="' + id + '"]',
      '#main-cart-items [data-dd-cart-item][data-variant-id="' + id + '"]',
      '[data-dd-cart-item][data-variant-id="' + id + '"]'
    ];

    var target = null;
    for (var i = 0; i < selectors.length; i++) {
      target = document.querySelector(selectors[i]);
      if (target) break;
    }
    if (!target) return false;

    var scrollHost = target.closest('[data-dd-cart-items], .drawer__inner, .cart__items, .js-contents');
    if (scrollHost && scrollHost.scrollHeight > scrollHost.clientHeight) {
      var hostRect = scrollHost.getBoundingClientRect();
      var itemRect = target.getBoundingClientRect();
      var delta = itemRect.top - hostRect.top - Math.max(0, (hostRect.height - itemRect.height) / 2);
      scrollHost.scrollTo({ top: scrollHost.scrollTop + delta, behavior: 'smooth' });
    } else if (typeof target.scrollIntoView === 'function') {
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    return true;
  }

  function scrollGiftIntoView(variantId) {
    if (scrollVariantIntoView(variantId)) return true;
    var rows = document.querySelectorAll('[data-dd-cart-item]');
    for (var i = 0; i < rows.length; i++) {
      var txt = String(rows[i].textContent || '').toLowerCase();
      if (txt.indexOf('color ring') === -1 && txt.indexOf('🎁') === -1) continue;
      if (typeof rows[i].scrollIntoView === 'function') {
        rows[i].scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      return true;
    }
    return false;
  }

  function scheduleGiftScroll(variantId) {
    var attempts = 0;
    var maxAttempts = 10;
    function run() {
      if (scrollGiftIntoView(variantId)) return;
      attempts += 1;
      if (attempts >= maxAttempts) return;
      setTimeout(run, 140);
    }
    setTimeout(run, 60);
  }

  function animateSlotOut(slot, clearHtml) {
    if (!slot) return;
    if (slot._ddOutTimer) {
      clearTimeout(slot._ddOutTimer);
      slot._ddOutTimer = null;
    }
    if (slot._ddInRaf) {
      cancelAnimationFrame(slot._ddInRaf);
      slot._ddInRaf = null;
    }
    slot.classList.remove('is-entering', 'is-exiting');
    slot.hidden = true;
    if (clearHtml) {
      slot.innerHTML = '';
      slot.removeAttribute('data-dd-bogos-render-key');
    }
  }

  function animateSlotIn(slot) {
    if (!slot) return;
    if (slot._ddOutTimer) {
      clearTimeout(slot._ddOutTimer);
      slot._ddOutTimer = null;
    }
    if (slot._ddInRaf) {
      cancelAnimationFrame(slot._ddInRaf);
      slot._ddInRaf = null;
    }
    slot.classList.remove('is-exiting');
    var wasHidden = !!slot.hidden;
    slot.hidden = false;
    if (wasHidden) {
      slot.classList.add('is-entering');
      slot._ddInRaf = requestAnimationFrame(function () {
        slot._ddInRaf = requestAnimationFrame(function () {
          slot._ddInRaf = null;
          slot.classList.remove('is-entering');
        });
      });
    }
  }

  /**
   * Slot shell visibility = Liquid only (data-dd-bogos-qualified / has-gift on each section render).
   * JS fills the card and handles claim; do not hide the slot from client cart heuristics (avoids fighting the server).
   */
  function renderSlot(slot, gift) {
    var state = getState();
    if (!state) return;
    if (!slot) return;

    var qualified = slot.getAttribute('data-dd-bogos-qualified') === 'true';
    var hasGiftDom = slot.getAttribute('data-dd-bogos-has-gift') === 'true';

    if (hasGiftDom || !qualified) {
      animateSlotOut(slot, true);
      return;
    }

    var thresholdMet = true;
    var bogosOffer = !!gift;

    var canClaim = !!(bogosOffer && state.detail && typeof state.detail.addGiftToCartFunc === 'function');
    var fallbackTitle = String(slot.getAttribute('data-dd-bogos-default-title') || 'Claim your Color Ring');
    var fallbackImage = String(slot.getAttribute('data-dd-bogos-default-image') || '');
    var rawTitle = gift ? String(gift.title || '') : '';
    var title =
      rawTitle && rawTitle.toLowerCase().indexOf('color ring') !== -1
        ? 'Claim your Color Ring'
        : rawTitle || fallbackTitle;
    /* Use gift thumbnail - wait for gift data to prevent FOUC from image swap */
    var variant = gift ? getPrimaryVariant(gift) : null;
    var giftImage = gift ? (gift.thumbnail || (variant && variant.thumbnail)) : null;
    var image = giftImage || fallbackImage;
    
    /* Don't render until we have the gift image to prevent FOUC */
    if (!giftImage && qualified && !hasGiftDom) {
      return;
    }

    /* Always show "Claim" (or "Adding...") - use disabled state instead of text change */
    var claimText = state.busy || state.pendingClaim ? 'Adding\u2026' : 'Claim';
    var disabled = state.busy || state.pendingClaim || !canClaim ? 'disabled' : '';
    var declinedBadge = state.declined
      ? '<span class="dd-bogos-declined-badge" aria-label="Gift offer declined">Declined</span>'
      : '';

    var renderKey = [
      thresholdMet ? 't1' : 't0',
      bogosOffer ? 'q1' : 'q0',
      state.evaluated ? 'e1' : 'e0',
      gift ? String(gift.id || '') : 'nogift',
      state.busy ? 'b1' : 'b0',
      state.pendingClaim ? 'p1' : 'p0',
      state.declined ? 'd1' : 'd0',
      String(image || '')
    ].join('|');

    if (!slot.hidden && slot.getAttribute('data-dd-bogos-render-key') === renderKey) return;

    /* Set content BEFORE animating in to prevent FOUC */
    slot.setAttribute('data-dd-bogos-render-key', renderKey);
    slot.innerHTML =
      '<div class="dd-bogos-card">' +
      (image
        ? '<div class="dd-bogos-media"><img src="' + esc(image) + '" alt="' + esc(title) + '" loading="lazy"></div>'
        : '<div class="dd-bogos-media dd-bogos-media--empty" aria-hidden="true"></div>') +
      '<div class="dd-bogos-body">' +
      '<p class="dd-bogos-title">' + esc(title) + declinedBadge + '</p>' +
      '<p class="dd-bogos-meta">Free gift available for this order</p>' +
      '</div>' +
      '<div class="mc26-bogos-actions">' +
      '<button type="button" class="mc26-bogos-claim' + (state.busy || state.pendingClaim ? ' is-pending' : '') + '" data-dd-bogos-claim ' + disabled + '>' + esc(claimText) + '</button>' +
      '<button type="button" class="mc26-bogos-decline' + (state.declined ? ' is-declined' : '') + '" data-dd-bogos-dismiss aria-label="Dismiss free gift">' +
      '<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line>' +
      '</svg>' +
      '</button>' +
      '</div>' +
      '</div>';
    /* Animate in AFTER content is set to prevent FOUC */
    animateSlotIn(slot);
  }

  function renderAll() {
    var state = getState();
    if (!state) return;
    syncTierStateBeforeRender();
    state = getState();
    if (!state) return;
    scheduleBogosUiSuppress();
    var slots = getSlots();
    var gifts = getGiftList(state.detail);
    var gift = gifts.length ? gifts[0] : null;
    for (var i = 0; i < slots.length; i++) {
      renderSlot(slots[i], gift);
    }
    if (typeof requestAnimationFrame === 'function') {
      requestAnimationFrame(hideDefaultBogosUi);
    }
  }

  var _renderRaf = null;
  function renderAllCoalesced() {
    if (_renderRaf) return;
    _renderRaf = requestAnimationFrame(function () {
      _renderRaf = null;
      renderAll();
    });
  }

  function invokeAddGiftToCart(addFn, variantId, offerId) {
    var variantNum = parseInt(variantId, 10);
    var variantStr = String(variantId || '');
    var hasOfferId = !isNaN(offerId) && offerId > 0;
    var calls = [];
    if (hasOfferId) {
      calls.push(function () { return addFn(variantNum, 1, offerId); });
      calls.push(function () { return addFn(variantStr, 1, offerId); });
    }
    calls.push(function () { return addFn(variantNum, 1); });
    calls.push(function () { return addFn(variantStr, 1); });

    var idx = 0;
    function runNext(lastErr) {
      if (idx >= calls.length) throw lastErr || new Error('addGiftToCartFunc failed');
      var result;
      try {
        result = calls[idx++]();
      } catch (err) {
        return runNext(err);
      }
      return Promise.resolve(result).then(function (value) {
        if (value === false) return runNext(new Error('addGiftToCartFunc returned false'));
        return value;
      });
    }
    return runNext();
  }

  function attemptClaimGift() {
    var state = getState();
    if (!state || !state.pendingClaim || state.busy) return;
    if (!state.thresholdMet || !state.qualifies) {
      patchState({ pendingClaim: false });
      _claimRetryCount = 0;
      renderAll();
      return;
    }
    if (!state.detail || typeof state.detail.addGiftToCartFunc !== 'function') {
      if (_claimRetryCount < MAX_CLAIM_RETRIES) {
        _claimRetryCount += 1;
        requestBogosGiftEval(true).finally(function () {
          attemptClaimGift();
        });
      } else {
        patchState({ pendingClaim: false });
        _claimRetryCount = 0;
      }
      renderAll();
      return;
    }

    var gifts = getGiftList(state.detail);
    var gift = gifts.length ? gifts[0] : null;
    var variant = getPrimaryVariant(gift);
    if (!gift || !variant || !variant.id) {
      patchState({ pendingClaim: false });
      renderAll();
      return;
    }

    var offerId = parseInt(gift.belongs_to_offer, 10);
    patchState({ busy: true, declined: false });
    renderAll();
    debugGift('claim:start', {
      offerId: isNaN(offerId) ? null : offerId,
      variantId: variant && variant.id ? String(variant.id) : null
    });

    var addFn = state.detail.addGiftToCartFunc;
    var variantIdForAdd = variant.id;

    function doClaimAndSync() {
      debugGift('claim:invoke-add', { offerId: isNaN(offerId) ? null : offerId });
      return invokeAddGiftToCart(addFn, variantIdForAdd, offerId)
        .then(function () {
          debugGift('claim:add-complete');
          return refreshCartUiAfterGiftClaim().catch(function () {});
        })
        .then(function () {
          debugGift('claim:refresh-complete');
          syncFromAttributes();
          return requestBogosGiftEval(true).then(function (cartData) {
            debugGift('claim:eval-complete', {
              hasCartData: !!(cartData && Array.isArray(cartData.items)),
              itemCount: cartData && typeof cartData.item_count === 'number' ? cartData.item_count : null
            });
            return cartData;
          });
        });
    }

    var addPromise;
    if (window.ddCartHelpers && typeof window.ddCartHelpers.enqueueExternalMutation === 'function') {
      addPromise = window.ddCartHelpers.enqueueExternalMutation({
        label: 'bogos-claim',
        requester: 'bogos',
        endpoint: '/cart/add.js',
        action: 'bogos-claim',
        timeoutMs: 20000,
        run: doClaimAndSync,
        invalidateFreshCart: true
      });
    } else {
      addPromise = doClaimAndSync();
    }

    addPromise
      .then(function () {
        var claimedVariantId = String(variant.id || '');
        patchState({ pendingClaim: false });
        _claimRetryCount = 0;
        scheduleGiftScroll(claimedVariantId);
        debugGift('claim:success', { claimedVariantId: claimedVariantId });
      })
      .catch(function (err) {
        debugGift('claim:error', {
          message: err && err.message ? err.message : String(err),
          code: err && err.code ? err.code : null
        });
        if (_claimRetryCount < MAX_CLAIM_RETRIES) {
          _claimRetryCount += 1;
        } else {
          patchState({ pendingClaim: false });
          _claimRetryCount = 0;
          if (typeof window.ddToast === 'function') {
            window.ddToast('Couldn\u2019t add gift \u2014 please try again', { type: 'error' });
          }
        }
      })
      .finally(function () {
        patchState({ busy: false });
        renderAll();
        if (getState() && getState().pendingClaim) attemptClaimGift();
      });
  }

  function requestBogosGiftEval(force) {
    var now = Date.now();
    if (!force && window._ddBogosEvalTs && now - window._ddBogosEvalTs < 500) return Promise.resolve();
    if (window._ddBogosEvalInFlight) return window._ddBogosEvalInFlight;

    window._ddBogosEvalTs = now;

    var cartPromise;
    if (window.ddCartHelpers && typeof window.ddCartHelpers.ensureFreshCart === 'function') {
      cartPromise = window.ddCartHelpers.ensureFreshCart({ forceNetwork: true });
    } else {
      cartPromise = fetch('/cart.js?_=' + Date.now(), {
        credentials: 'same-origin',
        cache: 'no-store'
      }).then(function (r) { return r.ok ? r.json() : null; });
    }

    window._ddBogosEvalInFlight = cartPromise
      .then(function (cartData) {
        if (!cartData) return null;
        applyCartSnapshot(cartData, { emitBogosEvent: true });
        return cartData;
      })
      .catch(function (err) {
        debugGift('eval:error', { message: err && err.message ? err.message : String(err) });
      })
      .finally(function () {
        window._ddBogosEvalInFlight = null;
      });

    return window._ddBogosEvalInFlight;
  }

  function extractCartFromDetail(detail) {
    if (window.ddCartHelpers && typeof window.ddCartHelpers.extractCartFromEventDetail === 'function') {
      return window.ddCartHelpers.extractCartFromEventDetail(detail);
    }
    if (!detail || typeof detail !== 'object') return null;
    if (Array.isArray(detail.items)) return detail;
    if (detail.cart && Array.isArray(detail.cart.items)) return detail.cart;
    if (detail.cartData && Array.isArray(detail.cartData.items)) return detail.cartData;
    return null;
  }

  function emitBogosGifts(cartData) {
    if (!cartData || !Array.isArray(cartData.items)) return;
    try {
      document.dispatchEvent(new CustomEvent('bogos:gifts', { detail: cartData }));
    } catch (emitError) {}
  }

  function applyCartSnapshot(cartData, options) {
    if (!cartData || !Array.isArray(cartData.items)) return false;
    var state = getState();
    if (!state) return false;
    var prevQualifies = state.qualifies;
    var hasGiftNow = cartData.items.some(function (item) {
      return isColorRingGiftItem(item);
    });
    var thresholdMet = mergeThresholdMet(cartData, !!state.thresholdMet);

    if (!thresholdMet) {
      clearEvalTimer();
      patchState({
        hasColorRingInCart: hasGiftNow,
        thresholdMet: false,
        qualifies: false,
        detail: null,
        evaluated: true
      });
      return true;
    }

    var qualifiesNow = hasGiftNow ? true : !!prevQualifies;
    patchState({
      hasColorRingInCart: hasGiftNow,
      thresholdMet: true,
      qualifies: qualifiesNow
    });

    if (hasGiftNow) {
      resolveEval();
      return true;
    }

    if (!state.pendingClaim && !state.busy) {
      scheduleEvalFallback();
      if (options && options.emitBogosEvent) emitBogosGifts(cartData);
    }
    return true;
  }

  function getClaimRefreshSections() {
    var isCartPage = /\/cart\b/.test(window.location.pathname || '');
    if (isCartPage) {
      var sections = ['cart-icon-bubble'];
      var mainItems = document.getElementById('main-cart-items');
      var mainFooter = document.getElementById('main-cart-footer');
      if (mainItems && mainItems.dataset && mainItems.dataset.id) sections.push(mainItems.dataset.id);
      if (mainFooter && mainFooter.dataset && mainFooter.dataset.id) sections.push(mainFooter.dataset.id);
      return sections;
    }
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  function fetchSectionsPayload(sectionIds) {
    if (!Array.isArray(sectionIds) || !sectionIds.length) return Promise.resolve(null);
    return fetch('/cart?sections=' + encodeURIComponent(sectionIds.join(',')) + '&_=' + Date.now(), {
      credentials: 'same-origin',
      cache: 'no-store'
    }).then(function (response) {
      if (!response.ok) throw new Error('Section refresh failed (' + response.status + ')');
      return response.json();
    });
  }

  function refreshCartUiAfterGiftClaim() {
    if (!window.ddCartHelpers || typeof window.ddCartHelpers.replaceCartSections !== 'function') {
      return Promise.resolve();
    }

    return fetchSectionsPayload(getClaimRefreshSections()).then(function (payload) {
      if (payload) window.ddCartHelpers.replaceCartSections(payload);
      _lastSectionRefreshTs = Date.now();
      var _giftPayload = { source: 'dd-cart-gift-claim', skipBogosEval: true };
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, _giftPayload);
      }
      try { document.dispatchEvent(new CustomEvent('cart:updated', { detail: _giftPayload })); } catch (eventError) {}
      return payload;
    });
  }

  function refreshCartUiFromBogosUpdate() {
    if (_lastSectionRefreshTs && Date.now() - _lastSectionRefreshTs < 600) return Promise.resolve();
    if (_eventRefreshInFlight) return _eventRefreshInFlight;
    _eventRefreshInFlight = refreshCartUiAfterGiftClaim()
      .catch(function () {})
      .finally(function () {
        _eventRefreshInFlight = null;
      });
    return _eventRefreshInFlight;
  }

  function bindEvents() {
    document.addEventListener('fg-gifts:show-slider', function (event) {
      resolveEval();
      var detail = event && event.detail ? event.detail : null;
      var hasOffer = getGiftList(detail).length > 0;
      var hasPayload = hasGiftPayload(detail);
      var nextState = { detail: detail };
      if (hasOffer) {
        nextState.qualifies = true;
      } else if (hasPayload) {
        nextState.qualifies = false;
      }
      patchState(nextState);
      renderAll();
      attemptClaimGift();
    });

    document.addEventListener('fg-gifts:updated', function (event) {
      var detail = event && event.detail ? event.detail : null;
      if (detail) {
        var hasOffer = getGiftList(detail).length > 0;
        var hasPayload = hasGiftPayload(detail);
        var next = { detail: detail };
        if (hasOffer) {
          next.qualifies = true;
          next.evaluated = true;
        } else if (hasPayload) {
          next.qualifies = false;
          next.evaluated = true;
        }
        patchState(next);
        if (hasOffer) resolveEval();
      }
      var cartData = extractCartFromDetail(event && event.detail ? event.detail : null);
      var shouldRefreshUi = false;
      if (cartData) {
        var before = getState() ? !!getState().hasColorRingInCart : false;
        applyCartSnapshot(cartData, { emitBogosEvent: false });
        var after = getState() ? !!getState().hasColorRingInCart : false;
        /* Only force section re-render when gift line presence changed.
           Threshold-only qualification updates should stay local to avoid
           repeated drawer rebuilds/flicker (FOUC). */
        shouldRefreshUi = before !== after;
      }

      var refreshPromise = shouldRefreshUi ? refreshCartUiFromBogosUpdate() : Promise.resolve();
      refreshPromise.finally(function () {
        renderAllCoalesced();
        attemptClaimGift();
      });
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (payload) {
        var cartData = extractCartFromDetail(payload);
        if (cartData && applyCartSnapshot(cartData, { emitBogosEvent: true })) {
          renderAllCoalesced();
          return;
        }
        if (payload && payload.skipBogosEval) {
          renderAllCoalesced();
          return;
        }
        requestBogosGiftEval(false).finally(renderAllCoalesced);
      });
    }

    /* Legacy DOM shim — kept during transition for third-party listeners */
    document.addEventListener('cart:updated', function (event) {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') return;
      var detail = event && event.detail ? event.detail : null;
      var cartData = extractCartFromDetail(detail);
      if (cartData && applyCartSnapshot(cartData, { emitBogosEvent: true })) {
        renderAllCoalesced();
        return;
      }
      if (detail && detail.skipBogosEval) {
        renderAllCoalesced();
        return;
      }
      requestBogosGiftEval(false).finally(renderAllCoalesced);
    });

    /* BOGOS render hook — previously called synchronously from
       dd-cart-helpers publishCartUpdate; now decoupled via PubSub */
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        try {
          if (window.DDCartGift && typeof window.DDCartGift.init === 'function') {
            window.DDCartGift.init();
          }
          if (typeof window._ddBogosInlineGiftRender === 'function') {
            window._ddBogosInlineGiftRender();
          } else if (window.DDCartGift && typeof window.DDCartGift.render === 'function') {
            window.DDCartGift.render();
          }
        } catch (bogosErr) {}
      });
    }

    document.addEventListener('fg-messages:render', function () {
      renderAllCoalesced();
      attemptClaimGift();
    });

    document.addEventListener('bogos:message', function () {
      renderAllCoalesced();
      attemptClaimGift();
    });

    document.addEventListener('drawer:opened', function () {
      if (window.DDCartGift && typeof window.DDCartGift.init === 'function') {
        window.DDCartGift.init();
      }
      renderAllCoalesced();
    });

    document.addEventListener('click', function (event) {
      var claim = event.target.closest('[data-dd-bogos-claim]');
      if (claim) {
        event.preventDefault();
        var state = getState();
        if (!state) return;
        if (
          state.thresholdMet &&
          state.qualifies &&
          state.detail &&
          typeof state.detail.addGiftToCartFunc === 'function'
        ) {
          patchState({ pendingClaim: true });
          _claimRetryCount = 0;
          attemptClaimGift();
        } else {
          requestBogosGiftEval(true).finally(function () {
            var s = getState();
            if (!s || !s.thresholdMet || !s.qualifies) {
              if (typeof window.ddToast === 'function') {
                window.ddToast('Gift requires qualifying cart conditions.', { type: 'info' });
              }
              return;
            }
            patchState({ pendingClaim: true });
            _claimRetryCount = 0;
            attemptClaimGift();
          });
        }
        return;
      }

      var dismiss = event.target.closest('[data-dd-bogos-dismiss]');
      if (dismiss) {
        event.preventDefault();
        patchState({ declined: true });
        renderAll();
      }
    });
  }

  var _initAttempts = 0;
  var MAX_INIT_ATTEMPTS = 40;

  function init() {
    if (_inited) return;
    if (!window.DDCartState) {
      _initAttempts += 1;
      if (_initAttempts <= MAX_INIT_ATTEMPTS) {
        setTimeout(init, 25);
      } else {
        console.warn('[dd-cart-gift] DDCartState never loaded — gift/promo mutex inactive. Ensure dd-cart-state.js runs before this file.');
      }
      return;
    }
    _inited = true;
    syncFromAttributes();
    bindEvents();
    window._ddBogosInlineGiftRender = renderAll;
    scheduleBogosUiSuppress();
    var state = getState();
    if (state && !state.hasColorRingInCart) requestBogosGiftEval(true);
    renderAll();
  }

  window.DDCartGift = {
    init: init,
    syncFromAttributes: syncFromAttributes,
    render: renderAll,
    requestEval: requestBogosGiftEval
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
